import { useCreateFirstPostTask } from 'app/modules/onboardingChecklist/tasks/useCreateFirstPostTask';
import { useSendPostForApprovalTask } from 'app/modules/onboardingChecklist/tasks/useSendPostForApprovalTask';
import { useConnectProfilesTask } from 'app/modules/onboardingChecklist/tasks/useConnectProfilesTask';
// import { useCreateFirstReportTask } from 'app/modules/onboardingChecklist/tasks/useCreateFirstReportTask';
import { useInviteTeammateTask } from 'app/modules/onboardingChecklist/tasks/useInviteTeammateTask';
import { ChecklistTaskHookResult } from 'app/modules/onboardingChecklist/types';

export const useChecklistTasks = (): ChecklistTaskHookResult[] => {
  const connectProfiles = useConnectProfilesTask();
  const createFirstPost = useCreateFirstPostTask();
  const sendPostForApproval = useSendPostForApprovalTask();
  // const createFirstReport = useCreateFirstReportTask();
  const inviteTeammate = useInviteTeammateTask();

  return [
    connectProfiles,
    createFirstPost,
    sendPostForApproval,
    // createFirstReport,
    inviteTeammate,
  ];
};
